<template>
	<div>
		<div class="content-assets">
			<div class="flex-cement1">
				<div class="cement">{{props.objList?.question}}</div>
				<div class="flex-const-slice" style="margin-left: 8px">
					<div>
						<img src="@/assets/contact_slices/Vector@2x (5).png" style="width: 14px; height: 14px" />
					</div>
					<div class="december">{{props.objList?.updateTime}}</div>
				</div>
				<div class="flex-contact-slices" @click="cloem">
					<img src="@/assets/contact_slices/Vector@2x (8).png" style="width: 14px; height: 14px;"/>
					<div class="assets-return">返回</div>
				</div>
			</div>
			<div class="border-top"></div>
			<div>
				{{props.objList.answer}}
			</div>
		</div>
	</div>
</template>

<script setup>
	let props = defineProps(['objList']);
	let emit = defineEmits(['closed']);
	const cloem = ()=>{
		emit('closed');
	}
</script>

<style lang="scss" scoped>
.content-assets {
	padding: 20px 21px;
	padding-: 26px;
}

.flex-cement1 {
	position: relative;
	
	.cement {
		font-family: PingFang SC, PingFang SC;
		font-weight: 600;
		font-size: 20px;
		color: #333333;
		margin-left: 8px;
		font-style: normal;
		text-transform: none;
	}
}

.flex-contact-slices{
	position: absolute;
	top: 0;
	right: 0;
	display: flex;
	align-items: center;
}

.flex-contact-slices:hover{
	cursor: pointer;
}

.assets-return{
	font-family: PingFang SC, PingFang SC;
	font-weight: 400;
	font-size: 16px;
	color: #333333;
	font-style: normal;
	text-transform: none;
	margin-left: 4px;
	margin-top: 2px;
}

.border-top {
	width: 99%;
	height: 0px;
	border-top: 1px solid #eeeeee;
	margin-top: 16px;
	padding-top: 16px;
}

.flex-const-slice {
	display: flex;
	margin-top: 10px;
}
.title-slice {
	font-family: PingFang SC, PingFang SC;
	font-weight: 400;
	font-size: 18px;
	color: #333333;
	text-align: left;
	font-style: normal;
	text-transform: none;
	margin-top: 2px;
}

.title-slice1 {
	color: #ff2f17;
}

.december {
	font-family: PingFang SC, PingFang SC;
	font-weight: 400;
	font-size: 17px;
	color: #aaaaaa;
	font-style: normal;
	text-transform: none;
	margin-left: 5px;
	margin-top: -2px;
}

.flex-top {
	display: flex;
	justify-content: space-between;
	align-items: center;
}
</style>
